import SERVICE_URL from "../config/API_DATA"
import HttpPost from "../http/httppost.js";
import Logger from './logger.js';
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

import { TRIP,DATE_TIME_FORMAT } from "../util/constants.js";
import { formatDate } from "../util/date/dateFunctions.js"

export default class CrsFareView {
    static buildRequest(pSearchObj,pContractId) {
        let returnValue = null;
        
        try {

            if(pSearchObj) {
                returnValue = this.formatSearchObject(pSearchObj,pContractId);
            }

            let body = returnValue;


            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(FILE_NAME.API_CRS_FARE_VIEW, "error in building body for CrsFareView api", err.toString(), "buildRequest", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {


        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(SERVICE_URL.CRS_FARE_VIEW, pReqOptions);
        } catch (err) {
            let body = Logger.buildRequest(FILE_NAME.API_CRS_FARE_VIEW, "error in getting Response from  CrsFareView api ", err.toString(), "getResponse", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        return returnValue;
    }

    ///to format a search object
  static formatSearchObject(pSearchObj,pContractId) {
    let retValue = null;
    try {

      let searchFormat = {
        searchOption: {
            Route: {
                From: null,
                To: null,
                DepDate: null,
                RetDate:  null
            },
            JourneyType: 1,
            preferredCurrency: null
        },
        contractId: null,
        bookingDate: null
      };
  if(pSearchObj.trip!=TRIP.MULTI_CITY){
      searchFormat.searchOption.Route.From =
        pSearchObj.route[TRIP.ONE_WAY - 1].from.depcode.airportcode;
      searchFormat.searchOption.Route.To =
        pSearchObj.route[TRIP.ONE_WAY - 1].to.depcode.airportcode;
        // searchFormat.searchOption.Route.DepDate = "2020-08-01"
      searchFormat.searchOption.Route.DepDate = formatDate(pSearchObj.route[TRIP.ONE_WAY - 1].date, DATE_TIME_FORMAT.API_DATE_FORMAT)
      if (pSearchObj.trip == TRIP.ROUND_TRIP) {
          searchFormat.searchOption.Route.RetDate =
            formatDate(pSearchObj.route[TRIP.ONE_WAY].date, DATE_TIME_FORMAT.API_DATE_FORMAT);
      } else {
        ///if not
        searchFormat.searchOption.Route.RetDate = null;
      }
      // searchFormat.bookingDate = null;
      searchFormat.bookingDate = formatDate(pSearchObj.bookingDate, DATE_TIME_FORMAT.API_DATE_FORMAT);
      searchFormat.contractId = pContractId;
      searchFormat.searchOption.JourneyType = pSearchObj.trip;
      if(pSearchObj.currency)
        {
      searchFormat.searchOption.preferredCurrency = pSearchObj.currency.currency_code.code;
        }
    }

      retValue = searchFormat;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_SEARCH_RESULT,
        "error while formating object",
        err.toString(),
        "formatSearchObject",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return retValue;
  }
}